import React, { useEffect } from 'react';
import { FormikProvider } from 'formik';

import { submitPhotographerApplication } from 'appAPI';
import { PhotographerApplicationDTO } from 'appAPITypes';
import { FormError } from 'primitives/input/formError';

import { PersonalInfos } from 'page/join/formSections/personalInfos';
import { JoinFormValidation } from './ProspectPhotographerDTOValidation';
import { Availability } from './formSections/availability';
import { Localisation } from './formSections/localisation/localisation';
import { ShText } from '@shoootin/translations';
import { getFrontMessage } from '../../appMessageDefinitions';
import { MaterialSection } from './formSections/materialSection';
import { useAppFormik } from '../../primitives/input/formikUtils';
import { AppButton } from '../../primitives/appButton';
import AppSection from '../../primitives/appSection';
import { H2, H4 } from '../../primitives/appTitle';
import { JoinPageTranslations } from './joinPageTranslations';
import { scrollToTop } from '../../utils/domUtils';

const JoinFormSubmittedSection = () => {
  useEffect(() => {
    scrollToTop();
  }, []);
  return (
    <AppSection
      className="photograph-availabilities left"
      header={
        <H2>
          <ShText message={JoinPageTranslations.submittedTitle} />
        </H2>
      }
    >
      <H4>
        <ShText message={JoinPageTranslations.submittedSubtitle} />
      </H4>
    </AppSection>
  );
};

const JoinForm = ({
  initialValues,
}: {
  initialValues: PhotographerApplicationDTO;
}) => {
  const { form, globalError, isSubmitSuccess } = useAppFormik({
    initialValues,
    validationSchema: JoinFormValidation,
    submitAppForm: submitPhotographerApplication,
  });
  if (isSubmitSuccess) {
    return <JoinFormSubmittedSection />;
  }
  return (
    <FormikProvider value={form}>
      <PersonalInfos form={form} />
      <Availability form={form} />
      <Localisation form={form} />
      <MaterialSection form={form} />
      <div className="container">
        <div css={{ display: 'flex', paddingTop: '1em', paddingBottom: '3em' }}>
          {globalError && <FormError error={globalError} />}
          <AppButton
            css={{ marginLeft: 'auto' }}
            modifier="large"
            onClick={() => {
              console.debug('submitting form');
              form.submitForm();
              console.debug('form submitted');
            }}
          >
            <ShText message={getFrontMessage('common_actions_submit')} />
          </AppButton>
        </div>
      </div>
    </FormikProvider>
  );
};

export default JoinForm;
